import { createSelector } from 'reselect'
import getNextTierInfoLoyaltySelect from 'modules/loyalty/redux/selectors/get-next-tier-info'

const getFastTrackExpireOnNextTierLoyaltySelect = createSelector(
  getNextTierInfoLoyaltySelect,
  /**
   * @param {NextTierInfo} nextTierInfo
   */
  nextTierInfo => {
    const fastTrackExpirationDateStr = nextTierInfo?.fast_track_expiration_date
    if (!fastTrackExpirationDateStr) {
      return
    }
    const fastTrackExpirationDate = new Date(fastTrackExpirationDateStr)
    return fastTrackExpirationDate
  }
)

export default getFastTrackExpireOnNextTierLoyaltySelect
